import type { Messages } from '@/i18n/types';

export const vi: Messages = {
  'lang.label': 'Ngôn ngữ',

  'nav.primary': 'Chính',
  'nav.about': 'Giới thiệu',
  'nav.features': 'Tính năng',
  'nav.owners': 'Cho chủ quán',
  'nav.download': 'Tải xuống',
  'nav.downloadCta': 'Tải ứng dụng',
  'nav.openMenu': 'Mở menu',
  'nav.closeMenu': 'Đóng menu',
  'nav.listStore': 'Đăng ký quán',
  'nav.stats': 'Con số',
  'nav.faq': 'FAQ',

  'hero.headline': 'Tìm quán nhậu đúng gu — tối nay.',
  'hero.sub':
    'Bản đồ chỗ trống, quán gần bạn, tweets từ khu phố, và tin nhắn khi muốn thêm bạn đồng bàn.',
  'hero.ageNote': 'Uống rượu dưới 18 tuổi bị luật cấm.',
  'hero.phoneAlt': 'Màn hình chính Nhậu Đee đang tìm quán trên bản đồ',

  'store.appStoreKicker': 'Download on the',
  'store.appStoreName': 'App Store',
  'store.appStoreAria': 'Tải trên App Store',
  'store.playKicker': 'Get it on',
  'store.playName': 'Google Play',
  'store.playAria': 'Tải trên Google Play',

  'about.title': 'Đêm nhậu dễ tìm hơn',
  'about.body':
    'Nhậu Đee giúp bạn tìm quán nhậu còn chỗ tối nay—bộ lọc bản đồ, danh sách quán gần kèm ảnh, tweets từ khu phố, và tin nhắn/Cheers khi muốn đi cùng bạn bè.',

  'features.eyebrow': 'Bạn có thể làm gì',
  'features.title': 'Đủ mọi thứ cho một đêm nhậu đúng gu',
  'features.summary.01': 'Bản đồ',
  'features.summary.02': 'Gần bạn',
  'features.summary.03': 'Tin nhắn',
  'features.summary.04': 'Tweets',
  'features.01.title': 'Tìm quán nhậu trên bản đồ',
  'features.01.body':
    'Khám phá bản đồ với bộ lọc chỗ trống tối nay và quán gần bạn—rồi mở những quán còn bàn hôm nay.',
  'features.01.phoneAlt': 'Bản đồ tìm quán nhậu',
  'features.02.title': 'Xem quán gần bạn',
  'features.02.body':
    'Cuộn danh sách ảnh quán gần đây kèm khoảng cách và địa chỉ, chọn chỗ mà không phải đoán mò.',
  'features.02.phoneAlt': 'Danh sách quán gần bạn',
  'features.03.title': 'Tin nhắn & Cheers',
  'features.03.body':
    'Khi muốn thêm bạn đồng bàn, xem Matches, chat và Cheers—hoặc xem gói premium nếu bạn mới bắt đầu.',
  'features.03.phoneAlt': 'Màn hình tin nhắn và Cheers',
  'features.04.title': 'Đọc tweets địa phương',
  'features.04.body':
    'Theo dõi bài đăng và đánh giá của khách gần bạn—lọc All, Shops, Users hoặc Diary để chọn quán đáng thử tối nay.',
  'features.04.phoneAlt': 'Bảng tin tweets',

  'pickup.tag': 'Tweets',
  'pickup.title': 'Giọng thật từ những bàn nhậu',
  'pickup.body':
    'Khách chia sẻ review ngắn về món nhậu, thời gian chờ và không khí bàn—để lần đi tiếp theo quen thuộc hơn một chút.',
  'pickup.imgAlt': 'Quán nhậu ban đêm với ly bia và đồ nướng',

  'stats.eyebrow': 'Nhậu Đee qua con số',
  'stats.title': 'Bản đồ quán nhậu đang mở rộng',
  'stats.shops': 'Quán đăng ký',
  'stats.shopsValue': 'TODO',
  'stats.areas': 'Khu vực',
  'stats.areasValue': 'TODO',
  'stats.users': 'Người dùng',
  'stats.usersValue': 'TODO',
  'stats.note': '*Số liệu tạm thời, sẽ cập nhật khi ra mắt.',

  'safety.eyebrow': 'An toàn',
  'safety.title': 'Khi muốn đi uống cùng ai đó',
  'safety.body': 'Tin nhắn và Cheers được thiết kế để dùng thoải mái và an toàn hơn.',
  'safety.1.title': 'Xác minh danh tính',
  'safety.1.body': 'Luồng xác minh giúp giảm rủi ro giả mạo.',
  'safety.2.title': 'Báo cáo & chặn',
  'safety.2.body': 'Báo cáo hoặc chặn bất kỳ ai khiến bạn khó chịu. Đội ngũ sẽ xem xét.',
  'safety.3.title': 'Xác minh tuổi',
  'safety.3.body': 'Vì dịch vụ liên quan đến rượu, chúng tôi kiểm tra độ tuổi (từ 18).',

  'faq.eyebrow': 'FAQ',
  'faq.title': 'Câu hỏi thường gặp',
  'faq.1.q': 'Có mất phí không?',
  'faq.1.a':
    'Tìm quán, danh sách và đọc tweets miễn phí. Một số tính năng tin nhắn/Cheers có thể cần Premium.',
  'faq.2.q': 'Có thật sự tìm được quán còn chỗ tối nay?',
  'faq.2.a':
    'Có—dùng tín hiệu chỗ trống và quán gần bạn. Trạng thái quán có thể đổi, hãy kiểm tra trong app.',
  'faq.3.q': 'An toàn và báo cáo thế nào?',
  'faq.3.a':
    'Với “đi cùng bạn”, bạn có thể báo cáo và chặn. Liên hệ trong app nếu có vấn đề.',
  'faq.4.q': 'Làm sao để đăng quán?',
  'faq.4.a':
    'Chủ quán bắt đầu miễn phí từ cổng chủ quán—chia sẻ chỗ trống, bài đăng, menu và nhân viên.',

  'links.title': 'Liên kết nhanh',
  'links.howItWorks': 'Nhậu Đee hoạt động thế nào',
  'links.forOwners': 'Dành cho chủ quán',
  'links.download': 'Tải ứng dụng',
  'links.privacy': 'Chính sách quyền riêng tư',
  'links.terms': 'Điều khoản sử dụng',
  'links.help': 'Trợ giúp',
  'links.contact': 'Liên hệ',

  'movie.eyebrow': 'Xem',
  'movie.title': 'Giới thiệu ứng dụng',
  'movie.imgAlt': 'Không khí quán nhậu',
  'movie.play': 'Phát video giới thiệu',
  'movie.soon': 'Video sắp ra mắt',

  'owners.eyebrow': 'Dành cho chủ quán',
  'owners.title': 'Tiếp cận khách đang tìm bàn tối nay',
  'owners.body':
    'Đăng quán, chia sẻ chỗ trống tối nay, đăng cập nhật, giới thiệu menu và nhân viên—bắt đầu miễn phí.',
  'owners.cta': 'Mở cổng chủ quán',
  'owners.signIn': 'Đã có tài khoản? Đăng nhập',

  'cta.title': 'Bắt đầu đêm nhậu tiếp theo với Nhậu Đee',
  'cta.sub': 'Tải ứng dụng và tìm quán vừa ý—ngay tối nay.',
  'cta.ageNote': 'Uống rượu dưới 18 tuổi bị luật cấm.',

  'footer.inquiry': 'Liên hệ',
  'footer.social': 'Mạng xã hội',
  'footer.about': 'Giới thiệu',
  'footer.owners': 'Chủ quán',
  'footer.help': 'Trợ giúp',
  'footer.privacy': 'Quyền riêng tư',
  'footer.terms': 'Điều khoản',
  'footer.company': 'Công ty vận hành',
  'footer.tokusho': 'Thông tin pháp lý',
  'footer.age': 'Uống rượu dưới 18 tuổi bị luật cấm.',
  'footer.facebook': 'Facebook',
  'footer.instagram': 'Instagram',
  'footer.x': 'X',

  'phone.nearYou': 'Gần bạn',
  'phone.counterOpen': 'Còn bàn · 0.4 km',
  'phone.barName': 'Quán Bia Hơi',
  'phone.barMeta': 'Quán nhậu · 50–150k',
  'phone.tonight': 'Tối nay',
  'phone.availableToday': 'Còn chỗ hôm nay',
  'phone.on': 'ON',
  'phone.quietCounter': 'Bàn ngoài trời',
  'phone.lateKitchen': 'Bếp muộn',
  'phone.storeName': 'Bia Hơi Góc Phố',
  'phone.menu': 'Menu',
  'phone.staff': 'Nhân viên',
  'phone.hours': 'Giờ mở',
  'phone.feed': 'Bảng tin',
  'phone.shop': 'Quán',
  'phone.shopPost': 'Set đồ nướng tối nay sẵn sàng cho bàn đông.',
  'phone.guest': 'Khách',
  'phone.guestPost': 'Ly bia lạnh, bàn đông vui — đúng gu tối nay.',
};
